import { React, useEffect, useState, useRef } from "react";
import "./UploadNomination.css";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TablePagination from "@mui/material/TablePagination";
import { useDispatch, useSelector } from "react-redux";
import {
  getTrainingListData,
  getCurrentMonth,
} from "../../app/DeliveryLeadershipSlice";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchCourse from "../SearchCourse";
import LeftArrow from "@mui/icons-material/KeyboardArrowLeft";
import RightArrow from "@mui/icons-material/KeyboardArrowRight";
import Button from "@mui/material/Button";
import { uploadNominations } from "../../app/DeliveryLeadershipSlice";

const UploadNomination = () => {
  const [nominateButton, setNominateButton] = useState(false);
  const [activeButton, setActiveButton] = useState(false);
  const [uploadNomination, setUploadNomination] = useState("");
  const [isExceptionalCase, setIsExceptionalCase] = useState(false);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [isSearchPerformed, setIsSearchPerformed] = useState(false);

  const dispatch = useDispatch();
  const {
    trainingData: trainingList,
    enterpriseID: userEnterpriseID,
    currentMonthIndex,
    loggedInUserRoles,
  } = useSelector((state) => state.deliveryLeadership);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploaded, setIsUploaded] = useState(false);
  const [before5WorkingDays, setBefore5WorkingDays] = useState(null);
  const [isExceptionPeriodCompleted, setIsExceptionPeriodCompleted] =
    useState(null);
  const [month, setMonth] = useState("");
  const [file, setFile] = useState("");
  const ref = useRef();
  const [filteredTrainingListStatus, setFilteredTrainingListStatus] =
    useState(0);
  const [filteredTrainingList, setFilteredTrainingList] = useState([]);
  const [selectedCourseDetails, setSelectedCourseDetails] = useState([]);
  //Selecting month and Date

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [year, setYear] = useState(new Date().getFullYear());
  const handledateChange = (value) => {
    setSelectedDate(value);
    const date = new Date(value);
    const month = date.getMonth() + 1; // Months are zero-based, so add 1
    const year = date.getFullYear();
    setMonth(month);
    setYear(year);
    dispatch(getTrainingListData(month, year));
    setPage(0);
  };
  const exceptionaluploadNominationsAccess = loggedInUserRoles.includes("th");
  const normaluploadNominationsAccess =  loggedInUserRoles.includes("requestor");
  console.log("exceptionaluploadNominationsAccess ->", exceptionaluploadNominationsAccess, 
    "normaluploadNominationsAccess ->",normaluploadNominationsAccess
  );
 
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const downloadFile = async (event) => {
    try {
      let fileUrl;
      let fileName;
      if (exceptionaluploadNominationsAccess && !before5WorkingDays) {
        fileUrl =
          process.env.PUBLIC_URL +
          "/template/ExceptionalTrainingNominationTemplate.xlsx";
        fileName = `ExceptionalTrainingNominationTemplate.xlsx`;
      } else {
        fileUrl =
          process.env.PUBLIC_URL + "/template/TrainingNominationTemplate.xlsx";
        fileName = `TrainingNominationTemplate.xlsx`;
      }
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(new Blob([blob]));

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${fileName}`; // Name of the file to be downloaded
      link.target = "_blank";

      // Trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };
  const sampleDownloadFile = async (event) => {
    try {
      let fileUrl;
      let fileName;
      if (exceptionaluploadNominationsAccess && !before5WorkingDays) {
        fileUrl =
          process.env.PUBLIC_URL +
          "/template/SampleExceptionalTrainingNomination.xlsx";
        fileName = `SampleExceptionalTrainingNomination.xlsx`;
      } else {
        fileUrl =
          process.env.PUBLIC_URL + "/template/SampleTrainingNomination.xlsx";
        fileName = `SampleTrainingNomination.xlsx`;
      }
      const response = await fetch(fileUrl);
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(new Blob([blob]));

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `${fileName}`; // Name of the file to be downloaded
      link.target = "_blank";

      // Trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };
  const [state, setState] = useState({
    openCopy: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, openCopy } = state;
  const handleClickCopy = (newState) => {
    setState({ ...newState, openCopy: true });
  };
  const handleCloseCopy = () => {
    setState({ ...state, openCopy: false });
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setLoading(false);
    setFile("");
    setIsUploaded(false);
    setSuccessMessage("");
    setErrorMessage("");
    setIsExceptionPeriodCompleted(false);
    setBefore5WorkingDays(false);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const handleUpload = () => {
    setLoading(true);

    const formData = new FormData();

    formData.append("file", file);

    let finalData = {
      case: isExceptionalCase,
      courseDetails: { sessionCode: selectedCourseDetails },
    };

    formData.append("finalData", JSON.stringify(finalData));

    dispatch(uploadNominations(formData, userEnterpriseID))
      .then((response) => {
        setIsUploaded(true);
        setErrorMessage("");
        setSuccessMessage(
          response?.data?.message || "File uploaded successfully.!!"
        );
        setLoading(false);
      })
      .catch((err) => {
        setErrorMessage(
          err?.response?.data?.message ||
            "An error occurred while uploading the file."
        );
        setLoading(false);
      });
  };

  const parseDate = (date) => {
    const [day, month, year] = date.split("-");
    return new Date(`${year}-${month}-${day}`);
  };

  // Function to calculate the date that is n working days before a given date
  const calculateWorkingDaysBefore = (date, n) => {
    const workingDaysBefore = new Date(date);
    let count = 0;
    while (count < n) {
      workingDaysBefore.setDate(workingDaysBefore.getDate() - 1);
      if (
        workingDaysBefore.getDay() !== 0 &&
        workingDaysBefore.getDay() !== 6
      ) {
        count++;
      }
    }
    return workingDaysBefore;
  };
  useEffect(() => {
    if (exceptionaluploadNominationsAccess && before5WorkingDays===false) {
      setIsExceptionalCase(true);
      console.log(
        "===== Case 1: User has TH access, and conditions are met for an exceptional case"
      );
    } else if (!exceptionaluploadNominationsAccess && before5WorkingDays) {
      setIsExceptionalCase(false);
      console.log("===== Case 2: When user is having Requestor access");
    } else {
      setIsExceptionalCase(false);
      console.log(
        "===== Case 3: Conditions are not met for an exceptional case"
      );
    }
  }, [exceptionaluploadNominationsAccess, before5WorkingDays]);
  const handleClick = (
    index,
    courseCode,
    startDate,
    sessionCode,
    courseName,
    endDate
  ) => {
    if (!exceptionaluploadNominationsAccess && !normaluploadNominationsAccess) {
      alert("Access is restricted, please contact for uploading L&TT POCs.");
      return;
    }
    setSelectedCourseDetails([]);
    setUploadNomination(index);

    setSelectedCourseDetails(() => {
      return sessionCode;
    });

    const currentDate = new Date();
    const toDate = currentDate;
    const courseDate = parseDate(startDate);
    const courseEndDate = parseDate(endDate);
    const fiveWorkingDaysBeforeStart = calculateWorkingDaysBefore(
      courseDate,
      5
    );

    // Case 1: Normal Case - Open the modal if current date is before 5-working-day period before start date
    if (toDate < fiveWorkingDaysBeforeStart) {
      console.log(
        "Normal Case: Current date is before the 5-working-day period before start date"
      );
      setBefore5WorkingDays(true);
      setIsExceptionPeriodCompleted(false);
      handleOpen(); // Open the modal
      return;
    }

    // Case 2: Exceptional Case - Open the modal if current date is on or before the end date
    else if (toDate <= courseEndDate) {
      console.log("Exceptional Case: Current date is on or before end date");
      setBefore5WorkingDays(false);
      setIsExceptionPeriodCompleted(false);
      handleOpen(); // Open the modal
      return;
    } else {
      // If neither case is met, do not open the modal
      console.log("Conditions not met for opening modal");
      setIsExceptionPeriodCompleted(true);
      setBefore5WorkingDays(false);
      handleOpen();
    }
  };

  const theme = createTheme({
    typography: {
      fontFamily: "Graphik-Regular",
    },
  });
  const saveFile = (e) => {
    setErrorMessage("");

    setFile(e.target.files[0]);
  };
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#7300bd" : "#7300bd",
    },
  }));

  useEffect(() => {
    dispatch(getCurrentMonth());
    if (currentMonthIndex && currentMonthIndex != undefined) {
      dispatch(getTrainingListData(month ? month : currentMonthIndex, year));
      setMonth(currentMonthIndex);
    }
  }, [currentMonthIndex]);

  const uploadModal = () => {
    return (
      <Box sx={style}>
        <span className="upload_close_btn_model" onClick={handleClose}>
          X
        </span>

        <Stack className="upload_button_modal_section">
          <Box>
            <Box>
              <Stack className="header_section_popup">
                <Typography className="header_typo_popup">
                  Upload Nomination
                </Typography>
              </Stack>
              <Stack className="pop_up_section">
                <Stack className="popup_course">
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "700",
                      display: "flex",
                    }}
                  >
                    Course Name:&nbsp;
                    <Box>
                      {/* <Tooltip title="click to copy"> */}
                      <span className="popup_span">
                        {trainingList[uploadNomination]?.courseName}
                      </span>
                      {/* </Tooltip>  */}
                      <Snackbar
                        className="copy-snackbar"
                        anchorOrigin={{ vertical, horizontal }}
                        open={openCopy}
                        autoHideDuration={1500}
                        onClose={handleCloseCopy}
                        message="copied"
                        key={vertical + horizontal}
                        sx={{ justifyContent: "center", display: "flex" }}
                      />
                    </Box>
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "700",
                      display: "flex",
                    }}
                  >
                    Course Code:&nbsp;
                    <span className="popup_span">
                      {trainingList[uploadNomination]?.courseCode}
                    </span>
                  </Typography>
                </Stack>
                <Stack className="popup_course">
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "700",
                      display: "flex",
                    }}
                  >
                    Session Code:&nbsp;
                    <Box>
                      <span className="popup_span">
                        {trainingList[uploadNomination]?.sessionCode}
                      </span>
                    </Box>
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "700",
                      display: "flex",
                    }}
                  >
                    Start Date:&nbsp;
                    <span className="popup_span">
                      {trainingList[uploadNomination]?.startDate}
                    </span>
                  </Typography>
                </Stack>
                <Stack className="popup_course">
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "700",
                      display: "flex",
                    }}
                  >
                    End Date:&nbsp;
                    <span className="popup_span">
                      {trainingList[uploadNomination]?.endDate}
                    </span>
                  </Typography>
                  {/* <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "700",
                      display: "flex",
                    }}
                  >
                    Total Seats:&nbsp;
                    <span className="popup_span">
                      {trainingList[uploadNomination]?.totalSeats}
                    </span>
                  </Typography> */}
                </Stack>
                <Stack className="popup_course"></Stack>
                {/* <Stack>
                  <Typography sx={{ fontSize: "11px" }}>
                    * Meaning - Waiting for Batch Allocation means nominations
                    are approved and seats are yet to be allocated.
                    <span>
                       <br></br>
                      Only Scheduled nominations are considered for attending
                      the training.
                    </span>
                  </Typography>
                </Stack> */}
              </Stack>
            </Box>
            {loading === true || isUploaded ? (
              <Box className="progressBar_section">
                <Typography sx={{ fontSize: "14px" }}>{file.name}</Typography>
                <Box className="progress_text_section">
                  <Box
                    sx={{
                      marginTop: "7px",
                    }}
                  >
                    <BorderLinearProgress
                      className="circular_progress_upload"
                      variant="determinate"
                      value={uploadProgress}
                    />
                  </Box>
                  <Box>
                    <Typography variant="caption" component="div" color="#000">
                      {uploadProgress != 0 &&
                      uploadProgress != undefined &&
                      uploadProgress != null &&
                      !errorMessage
                        ? uploadProgress
                        : null}
                      {uploadProgress != 0 &&
                      uploadProgress != undefined &&
                      uploadProgress != null &&
                      !errorMessage
                        ? "%"
                        : null}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ) : (
              ""
            )}

            {loading === true ? (
              <Typography className="uploading_file_text">
                Uploading file...
              </Typography>
            ) : isUploaded ? (
              <>
                <Typography className="uploading_file_text success">
                  {successMessage}
                </Typography>
              </>
            ) : (
              <>
                <Typography className="uploading_file_text_error">
                  {errorMessage}
                </Typography>
              </>
            )}
            {!isUploaded && !loading ? (
              <Box>
                <Stack
                  spacing={2}
                  direction={"row"}
                  alignItems={"center"}
                  className="select_file_section"
                >
                  <span className="file_caption">
                    {file.name != undefined && file.name != null
                      ? file.name
                      : "Choose files to upload"}
                  </span>
                  <input
                    type="file"
                    className="mainData"
                    accept=".xlsx"
                    ref={ref}
                    id="file"
                    onChange={saveFile}
                    hidden
                  />
                  <label htmlFor="file" className="custom-upload-btn">
                    Select File{" "}
                    <img
                      src="/images/Home/select-file-icon.png"
                      alt="icon"
                      className="file_name_plus_img"
                    />
                  </label>
                </Stack>
                <Button
                  className={
                    loading === false
                      ? "upload_button_modal_active"
                      : "upload_button_modal_inactive"
                  }
                  onClick={handleUpload}
                  sx={{ marginTop: "10px", marginLeft: "20px" }}
                >
                  Submit
                  <img
                    src="/images/Home/upload-icon_white.png"
                    alt="icon"
                    className="upload_img"
                  />
                </Button>
              </Box>
            ) : null}
            <div className="button_container">
              <Button
                className={
                  activeButton
                    ? "download_button_active"
                    : "download_button_inactive"
                }
                variant="contained"
                onClick={() => {
                  setActiveButton(!activeButton);
                }}
              >
                <a
                  href="#"
                  onClick={downloadFile}
                  className={
                    activeButton ? "download-link" : "download-link-inactive"
                  }
                >
                  Download Template
                </a>
                {activeButton ? (
                  <img
                    src="/images/Home/download-icon-white.png"
                    alt="icon"
                    className="download_img"
                  />
                ) : (
                  <img
                    src="/images/Home/download-icon.png"
                    alt="icon"
                    className="download_img"
                  />
                )}
              </Button>
            </div>
            <Box className="instructions_accordion">
              <Accordion
                sx={{
                  maxWidth: "100%",
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography sx={{ fontSize: "14px" }}>
                    Instructions
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ width: "100%" }}>
                  <Typography sx={{ fontSize: "12px" }}>
                    Please ensure the enterprise IDs are correct, Course Code
                    and Session Code and the Date is mentioned accurately.
                    <Typography sx={{ fontSize: "12px" }}>
                      <a href="#" onClick={sampleDownloadFile}>
                        Click here{" "}
                      </a>{" "}
                      to download sample nomination records.
                    </Typography>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Box>
          </Box>
        </Stack>
      </Box>
    );
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <div className="upload_section">
          <h3 className="upload_section_header">Upload Data</h3>
          <p className="upload_section_para">
            This section allows you to view the scheduled sessions and upload
            the nominations for a selected Training Session. Selecting a session
            will provide you the details like how many already nominated, how
            many rejected, how many are approved nominations who are yet to be
            allocated a batch.
          </p>
          <p className="upload_section_para">
            “My Nominations” section will allow you to view the status of the
            Nominations you uploaded.
          </p>
        </div>
        <SearchCourse
          trainingList={trainingList}
          setFilteredTrainingList={setFilteredTrainingList}
          setFilteredTrainingListStatus={setFilteredTrainingListStatus}
          setIsSearchPerformed={setIsSearchPerformed}
          isSearchPerformed={isSearchPerformed}
        />
        <Box className="select_month_section">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              gap: "10px",
            }}
            className="session__month_selector"
          >
            <DatePicker
              selected={selectedDate}
              placeholderText="MM/YYYY"
              className="month-year-picker"
              onChange={(date) => handledateChange(date)}
              dateFormat="MMMM, yyyy"
              showMonthYearPicker
              renderCustomHeader={({ date, changeYear }) => (
                <div className="custom-header">
                  <LeftArrow
                    className="arrow"
                    onClick={() => changeYear(date.getFullYear() - 1)}
                  />
                  <span>
                    {date.toLocaleString("default", { month: "long" })}{" "}
                    {date.getFullYear()}
                  </span>
                  <RightArrow
                    className="arrow"
                    onClick={() => changeYear(date.getFullYear() + 1)}
                  />
                </div>
              )}
            />
          </div>
        </Box>
        {trainingList.length != 0 ? (
          <Box>
            <Box className="upload_table">
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 650 }}
                  size="small"
                  aria-label="a dense table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Sl No</TableCell>
                      <TableCell align="center">Course Code</TableCell>
                      <TableCell align="center">Session Code</TableCell>
                      <TableCell align="center">Course Name</TableCell>
                      <TableCell align="center">Start Date </TableCell>
                      <TableCell align="center">End Date</TableCell>
                      <TableCell align="center">Session Type</TableCell>
                      <TableCell align="center">Duration</TableCell>
                      {/* <TableCell align="center">Total Seats Available</TableCell> */}

                      <TableCell
                        align="center"
                        className="fix"
                        // sx={{ width: "10%", background: "#7300BD" }}
                        sx={{ width: "10%" }}
                      ></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {trainingList.length != 0 &&
                      filteredTrainingListStatus === 0 && (
                        <UploadNominationTableList
                          trainingList={trainingList}
                          page={page}
                          rowsPerPage={rowsPerPage}
                          nominateButton={nominateButton}
                          setNominateButton={setNominateButton}
                          handleClick={handleClick}
                        />
                      )}
                    {trainingList.length != 0 &&
                      filteredTrainingListStatus === 1 && (
                        <UploadNominationTableList
                          trainingList={filteredTrainingList}
                          page={page}
                          rowsPerPage={rowsPerPage}
                          nominateButton={nominateButton}
                          setNominateButton={setNominateButton}
                          handleClick={handleClick}
                        />
                      )}
                    {trainingList.length != 0 &&
                      filteredTrainingListStatus === 1 &&
                      filteredTrainingList.length === 0 && (
                        <TableRow>
                          <TableCell>Searched courses not found.</TableCell>
                        </TableRow>
                      )}
                    <Modal
                      className="upload_modal"
                      open={open}
                      onClose={handleClose}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                    >
                      {before5WorkingDays &&
                      !exceptionaluploadNominationsAccess &&
                      !isExceptionPeriodCompleted ? (
                        // Normal case - within 5-working-day period before the start date
                        (console.log("Test 1 - Normal Case"), uploadModal())
                      ) : before5WorkingDays &&
                        exceptionaluploadNominationsAccess ? (
                        // Exceptional case during the normal period - within 5-working-day period with exceptional access
                        (console.log(
                          "Test 2 - Exceptional Case During Normal Period"
                        ),
                        uploadModal())
                      ) : !isExceptionPeriodCompleted &&
                        exceptionaluploadNominationsAccess ? (
                        // Exceptional case before or on session end date with exceptional access
                        (console.log(
                          "Test 3 - Exceptional Case Before or On Session End Date"
                        ),
                        uploadModal())
                      ) : isExceptionPeriodCompleted &&
                        exceptionaluploadNominationsAccess ? (
                        // After session end date
                        (console.log("Test 4 - After Session End Date"),
                        (
                          <Box
                            sx={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              width: 450,
                              bgcolor: "background.paper",
                              boxShadow: 24,
                              p: 1,
                            }}
                          >
                            <span
                              className="upload_close_btn_model"
                              onClick={handleClose}
                            >
                              X
                            </span>

                            <Typography
                              sx={{
                                textAlign: "center",
                                fontSize: "16px",
                                color: "blueviolet",
                                padding: "30px 10px 30px 10px",
                              }}
                            >
                              <h5 style={{ color: "red", marginBottom: "5px" }}>
                                SESSION COMPLETED
                              </h5>
                              This window is closed as the session has been
                              completed.
                            </Typography>
                          </Box>
                        ))
                      ) : (
                        // Default case: Nominations outside the allowed period (not within the 5-working-day window for normal case)
                        <Box
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: 450,
                            bgcolor: "background.paper",
                            boxShadow: 24,
                            p: 1,
                          }}
                        >
                          <span
                            className="upload_close_btn_model"
                            onClick={handleClose}
                          >
                            X
                          </span>

                          <Typography
                            sx={{
                              textAlign: "center",
                              fontSize: "16px",
                              color: "blueviolet",
                              padding: "30px 10px 30px 10px",
                            }}
                          >
                            <h5 style={{ color: "red", marginBottom: "5px" }}>
                              Nominations Closed
                            </h5>
                            Sorry! Nominations can only be made within 5 working
                            days before the start of the courses. After this
                            period, nominations are closed.{" "}
                          </Typography>
                        </Box>
                      )}
                    </Modal>
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                className="upload_nomination_pagination"
                component="div"
                count={
                  isSearchPerformed
                    ? filteredTrainingList && filteredTrainingList.length > 0
                      ? filteredTrainingList.length
                      : 0
                    : trainingList.length
                }
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{ width: "100% !important" }}
              />
            </Box>

            <div className="span_note_section">
              <span>
                <strong>Note: </strong>Please make sure to upload the file in
                the given format or else the nomination list will not be
                updated.
              </span>
            </div>
          </Box>
        ) : (
          <Stack
            justifyContent={"center"}
            alignItems={"center"}
            sx={{ marginTop: "30px", marginBottom: "100px" }}
          >
            <Stack
              spacing={2}
              justifyContent={"center"}
              alignItems={"center"}
              sx={{
                border: "solid 1px #DEDEDE",
                borderRadius: "5px",
                width: "70%",
                padding: "30px",
              }}
            >
              <img
                style={{ width: "100px" }}
                src="/images/POC/norecords.png"
              ></img>
              <Stack direction={"row"} spacing={1}>
                <img
                  style={{ width: "18px", height: "21px", marginTop: "3px" }}
                  src="/images/POC/norecordsalert.png"
                ></img>
                <Typography sx={{ fontSize: "20px" }}>
                  Training List for this month has not published yet!!!
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        )}
      </ThemeProvider>
    </>
  );
};
function UploadNominationTableList({
  page,
  rowsPerPage,
  trainingList,
  nominateButton,
  setNominateButton,
  handleClick,
}) {
  return (
    <>
      {trainingList
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => (
          <TableRow key={row.sno}>
            <TableCell align="center" scope="row">
              {row.sno}.
            </TableCell>
            <TableCell align="center" scope="row">
              {row.courseCode}
            </TableCell>
            <TableCell align="center">{row.sessionCode}</TableCell>
            <TableCell align="center">{row.courseName}</TableCell>
            <TableCell align="center">{row.startDate}</TableCell>
            <TableCell align="center">{row.endDate}</TableCell>
            <TableCell align="center">{row.sessionType}</TableCell>
            <TableCell align="center">{row.duration}</TableCell>
            {/* <TableCell align="center">{row.totalSeats}</TableCell> */}
            <TableCell align="center" className="fix">
              <Typography
                className={
                  nominateButton === index
                    ? "nominate_text_inactive"
                    : "nominate_text_active"
                }
                onClick={() => {
                  setNominateButton(index);
                  handleClick(
                    row.sno - 1,
                    row.courseCode,
                    row.startDate,
                    row.sessionCode,
                    row.courseName,
                    row.endDate
                  );
                }}
              >
                Nominate
              </Typography>
            </TableCell>
          </TableRow>
        ))}
    </>
  );
}
export default UploadNomination;
